import { some } from 'lodash';
import { useSessionState } from 'pe-core-frontend';
export const useActivityFilter = ({ key }) => {
    const [filter, setFilter] = useSessionState(`activityFilter-${key}`, {});
    const statuses = filter.status
        ? Array.isArray(filter.status)
            ? filter.status
            : [filter.status]
        : [];
    if (statuses.includes('closed')) {
        // closed is a special status that includes both 'closed' and 'not_covered' and 'denied'
        statuses.push('not_covered');
        statuses.push('denied');
    }
    const hasFilter = some(Object.keys(filter), key => filter[key]);
    return { filter, setFilter, hasFilter, statuses };
};
